import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

export const IconItemSchema = buildEntrySchemaFor('iconItem', {
  fields: z.lazy(() =>
    z.object({
      eyebrow: safeOptional(z.string()),
      heading: RichTextSchema.optional(),
      description: RichTextSchema.optional(),
      icon: z.string().optional(),
    }),
  ),
})
export type IconItem = z.infer<typeof IconItemSchema>
